import styled from 'styled-components';
import { getFont, getType, getWeight, getVariant } from '../utils';

export const Span = styled.span`
  ${({ type }) => getType('span', type)}

  ${({ variant, modifier }) => getVariant(variant, modifier)}

  ${({ weight }) => getWeight('span', weight)}

  ${({ font }) => getFont('span', font)}
`;
